import { buildRels } from "@src/utils/request"
import url from "url"

const included = [
  "user",
  "special-listening-radio",
  "favorite-radio",
  "first-favorite-category",
  "second-favorite-category",
  "third-favorite-category",
  "first-favorite-album",
  "second-favorite-album",
  "third-favorite-album",
  "first-favorite-collection",
  "second-favorite-collection",
  "third-favorite-collection",
]

export const createPath = (pathname, query) => {
  return url.format({
    pathname,
    query,
  })
}

export const createUserYearPath = (query) => {
  return createPath("user-annual-summaries", {
    ...query,
    include: included.join(","),
  })
}

export const parseGameData = (res) => {
  if (!res.data || !res.included) {
    return null
  }
  const { included } = res
  const game = included.find((e) => e.type === "games")?.attributes
  const team = included.find((e) => e.type === "organizations")?.attributes.name
  const members = included
    .filter((e) => e.type === "users")
    .map((e) => e.attributes.nickname)
  if (game && team) {
    return {
      game,
      team,
      members,
    }
  }
  return null
}

export const parseData = (res, { myself }) => {
  const builded = buildRels(res)
  console.log("parseData:res", res)
  console.log("parseData:builded", builded)
  if (!builded || builded.length === 0) {
    return null
  }
  const yearData = builded.find((y) => y.attributes.year === 2021)
  console.log("parseData:yearData", yearData)
  if (!yearData) {
    return null
  }
  const { attributes, rels } = yearData
  return {
    myself,
    loaded: true,
    token: attributes?.token,

    categories: [
      rels["first-favorite-category"],
      rels["second-favorite-category"],
      rels["third-favorite-category"],
    ].filter((item) => !!item),
    albums: [
      rels["first-favorite-album"],
      rels["second-favorite-album"],
      rels["third-favorite-album"],
    ].filter((item) => !!item),
    collections: [
      rels["first-favorite-collection"],
      rels["second-favorite-collection"],
      rels["third-favorite-collection"],
    ].filter((item) => !!item),
    attributes,
    ...rels,
  }
}
